import React from 'react';
import { colors } from 'seedling/constants';

function ReportBarGraphIcon({ color, size }) {
  return (
    <svg idth={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 5C3.25 4.58579 2.91421 4.25 2.5 4.25C2.08579 4.25 1.75 4.58579 1.75 5V15C1.75 15.4142 2.08579 15.75 2.5 15.75H17.5C17.9142 15.75 18.25 15.4142 18.25 15C18.25 14.5858 17.9142 14.25 17.5 14.25H3.25V5ZM6.5 5.5C6.22386 5.5 6 5.72386 6 6V12C6 12.2761 6.22386 12.5 6.5 12.5H7.27778C7.55392 12.5 7.77778 12.2761 7.77778 12V6C7.77778 5.72386 7.55392 5.5 7.27778 5.5H6.5ZM9.11108 9C9.11108 8.72386 9.33494 8.5 9.61108 8.5H10.3889C10.665 8.5 10.8889 8.72386 10.8889 9V12C10.8889 12.2761 10.665 12.5 10.3889 12.5H9.61108C9.33494 12.5 9.11108 12.2761 9.11108 12V9ZM12.7222 7.5C12.446 7.5 12.2222 7.72386 12.2222 8V12C12.2222 12.2761 12.446 12.5 12.7222 12.5H13.4999C13.7761 12.5 13.9999 12.2761 13.9999 12V8C13.9999 7.72386 13.7761 7.5 13.4999 7.5H12.7222Z"
      />
    </svg>
  );
}

ReportBarGraphIcon.defaultProps = {
  color: colors.mediumGrey,
  size: 20,
};

export default ReportBarGraphIcon;
